import React, { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { Box, Button, TextField, Select, FormControl, MenuItem, Tooltip } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DatePicker from "react-multi-date-picker";
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

// import Accordion from "@mui/material/Accordion";
// import AccordionSummary from "@mui/material/AccordionSummary";
// import AccordionDetails from "@mui/material/AccordionDetails";
// import moment from "moment";
// import { ModeCommentRounded } from "@mui/icons-material";
import {
  Divider,
} from "@mui/material";

function a11yProps(value) {
  if (!value) {
    return {
      disabled: true,
      style: { backgroundColor: "#ececec" },
    };
  }
}

function CustomMultipleInput({ openCalendar, value }) {
  return (
    <div>
      <input type="hidden"
        onFocus={openCalendar}
        value={value}
        readOnly
      />
      <CalendarTodayIcon onClick={openCalendar} />
    </div>
  )
}

export default function Schedule(props) {
  const { depends_on, onState, activeStep, start_date, end_date, numberOfTrainee,  handleBack, handleNext, classes } = props;

  const [temporary, settemporary] = React.useState([]);
  const [feedbackState, setFeedbackState] = React.useState({});
  const [selectedDates, setSelectedDates] = React.useState([]);
  const [emailError, setEmailError] = useState('');
  const [bothChecked, setBothChecked] = React.useState(false);
  const [bothValue, setBothValue] = React.useState(false);

  const [masterValue, setMasterValue] = useState('');
  const [masterOrRelatedLab, setMasterOrRelatedLab] = useState('');
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedRelatedLabType, setSelectedRelatedLabType] = useState('');
  const [selectedMasterLabId, setselectedMasterLabId] = useState('');
  const [lablist, setLabList] = useState([]);
  const [traineeCount, setTraineeCount] = useState(0);
  const [manageState, setManageState] = React.useState('');
  

  const [checkstate, setCheckstate] = React.useState({selectedValue: "",});

  const [labtypeoptionslist, setLabTypeOptionsList] = useState([
    { id: 'preconfig', value: 'Preconfigured' },
    { id: 'custom', value: 'Custom' },
    { id: 'hypervised', value: 'Hypervised' },
    { id: 'shared', value: 'Shared' },
    { id: 'wise', value: 'Wise' },
    // { id: 'cloud', value: 'Cloud' },
    { id: 'manual', value: 'Manual' },
  ]);


  function handleDateChange(date) {
    const formattedDates = date.map((d) => d.format("DD/MM/YYYY"));
    const selectedDatesCount = (formattedDates.length).toString();

    setSelectedDates(formattedDates);
    const id = "selectedDates";
    onState((prevState) => ({
      ...prevState,
      [id]: formattedDates.join(","),
    }));
    const id1 = "feedbackno";
    onState((prevState) => ({
      ...prevState,
      [id1]: selectedDatesCount,
    }));
  }

  const handlecheckChange = (event) => {
    setCheckstate({ ...checkstate, [event.target.name]: event.target.checked });
  };

  const handlecheckFeedbackChange = (event) => {
    // const name = "feedbackCheckboxValue";
    const id = "feedbackState";
    setFeedbackState({ ...feedbackState, [event.target.name]: event.target.checked });
    onState((prevState) => ({
      ...prevState,
      [id]: feedbackState ? "Yes" : "No",
    }));
  };

  const handlecheckBudgetChange = (event) => {
    
    onState((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.checked,
    }));
    settemporary((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.checked,
    }));
  };

  const handlecheckRelatedLabChange = (event) => {
    const { name, checked } = event.target;

    setSelectedRelatedLabType('');
    setselectedMasterLabId();
    
    settemporary((prevState) => ({
      ...prevState,
      [name]: checked,
    }));
  
    onState((prevState) => ({
      ...prevState,
      [name]: checked,
    }));

    console.log("checked----->", temporary.guacmoleLabState)
  };

  const handlecheckManageLabChange = (event) => {
    const id = "manageState";
    setManageState({ ...manageState, [event.target.name]: event.target.checked });
    onState((prevState) => ({
      ...prevState,
      [id]: manageState ? "Yes" : "No",
    }));
  };

  const handleReload = () => {
    window.location.reload();
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/;
    if (id === 'email') {
      // setEmailError('Please enter the email in correct format');
      const emailArray = value.split(',');
      for (const email of emailArray) {
        if (!emailRegex.test(email.trim())) {
          setEmailError('Invalid email address(es). Please use a valid format.');
          onState((prevState) => ({
            ...prevState,
            [id]: "",
          }));
          settemporary((prevState) => ({
            ...prevState,
            [id]: "",
          }));
          return;
        }
      }
      setEmailError('');
      onState((prevState) => ({
        ...prevState,
        [id]: value,
      }));
      settemporary((prevState) => ({
        ...prevState,
        [id]: value,
      }));
    } else {
      setEmailError('');
      onState((prevState) => ({
        ...prevState,
        [id]: value,
      }));
      settemporary((prevState) => ({
        ...prevState,
        [id]: value,
      }));
    }
  };

  const handleMeetingLinkChange = (e) => {
    const { id, value } = e.target;
    onState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
    settemporary((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  }

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  // Handle change of first dropdown (lab type)
  const handleLabTypeChange = (event) => {
    setselectedMasterLabId('');
    setSelectedRelatedLabType(event.target.value);

    const { name, value } = event.target;
    onState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    settemporary((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    let labListName = ""
    setLabList([]);
    if (event.target.value === "preconfig") {
      labListName = "preconfiguredlablist"
    }
    else if (event.target.value === "custom") {
      labListName = "customlablist"
    }
    else if (event.target.value === "hypervised") {
      labListName = "hypervisedlablist"
    }
    else if (event.target.value === "shared") {
      labListName = "sharedvmlabslist"
    }
    else if (event.target.value === "wise") {
      labListName = "wiselabslist"
    }
    else if (event.target.value === "manual") {
      labListName = "manuallabslist"
    }
    if (labListName !== "") {
      let org_id = "org_0001"
      fetch(`${process.env.REACT_APP_API_URL}/api/${labListName}/${org_id}/`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
        .then((resp) => resp.json())
        .then((data) => {
          setDialogOpen(false);
          setLabList(data);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

// Handle changes in the second dropdown
  const handleLabNameChange = (event) => {
    const selectedLabId = event.target.value;
    setselectedMasterLabId(selectedLabId);

    const { name, value } = event.target;
    onState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    settemporary((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    
    // Find the selected lab from the lablist
    const selectedLab = lablist.find((lab) => lab.id === parseInt(selectedLabId));
    
    if (selectedLab) {
      setTraineeCount(selectedLab.traineeCount); // Update the traineeCount state
    }

    if (parseInt(numberOfTrainee) === parseInt(selectedLab.traineeCount)) {
      
      setDialogOpen(false);
    } else {
      setselectedMasterLabId('');
      setDialogOpen(true);
    }
  };

  useEffect(() => {
    // if (lablist.length > 0 && !selectedMasterLabId) {
    //   setselectedMasterLabId(lablist[0].id); // Set first lab as default
    // }
    setMasterValue('');
    setMasterOrRelatedLab('');

  }, [temporary.guacmoleLabState, lablist]);

  useEffect(() => {
    setSelectedDates([]);
    const id = "selectedDates";
    onState((prevState) => ({
      ...prevState,
      [id]: "",
    }));

    const id1 = "feedbackno";
    onState((prevState) => ({
      ...prevState,
      [id1]: "",
    }));

    const id2 = "feedbackState";
    onState((prevState) => ({
      ...prevState,
      [id2]: "",
    }));
  }, [feedbackState]);

  useEffect(() => {
    const id = "env_keep_date"
    onState((prevState) => ({
      ...prevState,
      [id]: "",
    }));
    settemporary((prevState) => ({
      ...prevState,
      [id]: "",
    }));
  }, [temporary.env_keep]);

  useEffect(() => {
    if (checkstate.checkedB && feedbackState.feedbackCheckbox) {
      setBothChecked(true);
      if (temporary.email && selectedDates.length) {
        setBothValue(true);
      } else {
        setBothValue(false);
      }
    } else {
      setEmailError('');
      setBothChecked(false);
      setBothValue(false);
    }
  }, [checkstate.checkedB, feedbackState.feedbackCheckbox, temporary.email, selectedDates]);

  const getTenDaysAfterEndDate = (endDate) => {
    if (!endDate) {
      return "";
    }
    const date = new Date(endDate);
    date.setDate(date.getDate() + 10); // Adds 10 days to the end date
  
    // Format the date to "YYYY-MM-DD"
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
  
    return `${year}-${month}-${day}`;
  };

  return (
    <React.Fragment>
      <Dialog open={dialogOpen} onClose={handleDialogClose}>
        <DialogTitle>Notification !</DialogTitle>
        <DialogContent>
        <p>The selected master lab allows {traineeCount} trainees, but you requested lab trainee count - {numberOfTrainee}. To proceed, either:
            Update your requested [current] lab trainee count, or
            Select a different master lab that supports.
        </p>
        </DialogContent>
        <DialogActions>
          <Tooltip title="Close dialog"><span>
          <Button onClick={handleDialogClose} color="primary" autoFocus sx={{ borderRadius: '50px' }}>
            Ok
          </Button>
          </span></Tooltip>
        </DialogActions>
      </Dialog>
      <Box sx={{ pb: 2, border: '1px #000', borderRadius: '5px', padding: '10px' }}>
        <Box sx={{ pb: 2 }} style={{ marginBottom: '-30px' }}>
          <Typography variant="h6" gutterBottom>
            {" "}
            Notification{" "}
          </Typography>
        </Box>
        <Grid item xs={12} style={{ marginTop: "-18px" }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={checkstate.checkedB}
                onChange={handlecheckChange}
                name="checkedB"
                color="secondary"
              />
            }
            label={
              <Typography variant="h6"> Receive Labs Details Alerts </Typography>
            }
          />
        </Grid>
        <Typography variant="h8">
          Lab start/stop notifications are sent to the lab creator by default. To include additional users, provide their email addresses below.
        </Typography>
        <Grid item xs={12} sx={{ pt: 2, marginTop: '-10px' }} >
          <Grid item md={6} xs={12}>
            <Typography variant="h6"> Email Address: </Typography>
            <TextField
              fullWidth
              name="email"
              id="email"
              onChange={handleChange}
              required
              type="email"
              placeholder={localStorage.getItem("email")}
              {...a11yProps(checkstate.checkedB)}
              variant="outlined"
              InputProps={{
                style: {
                  height: "40px",
                },
              }}
              error={!!emailError}
              helperText={emailError}
            ></TextField>
          </Grid>
          <Typography variant="h5">
            <small>
              Note: Provide the email addresses in comma-separated format
            </small>
          </Typography>
        </Grid>
      </Box>
      <Divider style={{ marginBottom: "20px" }} />
      <Box sx={{ pb: 2, border: '1px #000', borderRadius: '5px', padding: '10px' }}>
        <Box sx={{ pb: 2 }}>
            <Typography variant="h6" gutterBottom>
              {" "}
              Link Lab{" "}
            </Typography>
        </Box>
        <Grid item xs={12} style={{ marginTop: "-25px" }}>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  onChange={handlecheckRelatedLabChange}
                  name="guacmoleLabState"
                  color="secondary"
                  checked={temporary.guacmoleLabState || false} // Ensure correct checked state
                />
              }
              label={<Typography variant="h6"> Link this lab with existing lab </Typography>}
            />
          </Grid>
        </Grid>
        {temporary.guacmoleLabState && (
          <Box sx={{ pb: 2, border: '1px solid #000', borderRadius: '5px', padding: '10px' }}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Select Lab Type"
                  name="selectedRelatedLabType"
                  id="selectedRelatedLabType"
                  value={selectedRelatedLabType}
                  onChange={handleLabTypeChange}
                  required
                  select
                >
                  {labtypeoptionslist.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                      {option.value}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Select Lab Name"
                  name="selectedMasterLabId"
                  id="selectedMasterLabId"
                  value={selectedMasterLabId || ''} // Ensure it's always a valid string
                  onChange={handleLabNameChange}
                  select
                  required
                >
                  {lablist.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                      {option.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
            </Grid>
          </Box>
        )}
      </Box>
      <Divider style={{ marginBottom: "20px" }} />
      <Box sx={{ pb: 2, border: '1px #000', borderRadius: '5px', padding: '10px' }}>
        <Box sx={{ pb: 2 }}>
          <Typography variant="h6" gutterBottom>
            {" "}
            Feedback{" "}
          </Typography>
        </Box>
        <Grid item xs={12} style={{ marginTop: "-30px" }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={feedbackState.feedbackCheckbox}
                onChange={handlecheckFeedbackChange}
                name="feedbackCheckbox"
                color="secondary"
              />
            }
            label={
              <Typography variant="h6"> Check the box and select the dates if trainees are required to submit feedback. </Typography>
            }
          />
        </Grid>
        <Grid item xs={12} >
          <Grid item md={6} xs={12}>
            {/* <Typography variant="h6"> Feedback Number </Typography>
          <TextField
            fullWidth
            name="feedbackno"
            id="feedbackno"
            onChange={handleChange}
            required
            autoComplete="feedbackno"
            type="number"
            {...a11yProps(feedbackState.feedbackCheckbox)}
            variant="outlined"
            inputProps={{ min: "0", max: "25", step: "1" }}
            InputProps={{
              style: {
                height: "40px",
              },
            }}
          ></TextField> */}
            <Box marginTop={0}>
              <Typography variant="h6"> Choose the dates for submitting feedback
                <DatePicker
                  multiple
                  id="selectedDates"
                  style={{ marginRight: "10px" }}
                  render={<CustomMultipleInput />}
                  onChange={handleDateChange}
                  {...a11yProps(feedbackState.feedbackCheckbox)}
                  value={selectedDates.map((d) => new Date(d.split("/").reverse().join("-")))}
                  // minDate={start_date}
                  // maxDate={end_date}
                />
              </Typography>
              {selectedDates.length > 0 && (
                <Typography style={{ marginTop: "10px" }} variant="body1">
                  <Typography variant="h6" component="span">Selected Dates:</Typography>{" "}
                  {selectedDates.join(", ")}
                </Typography>
              )}
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Divider style={{ marginBottom: "20px" }} />
      <Box sx={{ pb: 2, border: '1px #000', borderRadius: '5px', padding: '10px' }}>
        <Box sx={{ pb: 2 }}>
          <Typography variant="h6" gutterBottom>
            {" "}
            Manage Labs{" "}
          </Typography>
        </Box>
        <Grid item xs={12} style={{ marginTop: "-25px" }}>
          <Grid item xs={3}>
            <FormControlLabel
              control={
                <Checkbox
                  onChange={handlecheckManageLabChange}
                  name="manage_lab"
                  color="secondary"
                  disabled={depends_on !== "during_training"}
                />
              }
              label={<Typography variant="h6"> During Training Hours </Typography>}
            />
          </Grid>
        </Grid>
        <Typography variant="h8">
          Allow users to start/stop lab servers beyond training hours.
        </Typography>
      </Box>
      <Divider style={{ marginBottom: "20px" }} />
      <Box sx={{ pb: 2, border: '1px #000', borderRadius: '5px', padding: '10px' }}>
        <Box sx={{ pb: 2 }}>
          <Typography variant="h6" gutterBottom>
            {" "}
            Keep Lab Environment{" "}
          </Typography>
        </Box>
        <Grid item xs={12} style={{ marginTop: "-25px" }}>
          <Grid item xs={3}>
            <FormControlLabel
              control={
                <Checkbox
                  onChange={handlecheckBudgetChange}
                  name="env_keep"
                  color="secondary"
                />
              }
              label={<Typography variant="h6"> Retain the lab environment </Typography>}
            />
          </Grid>
          {temporary.env_keep ? (
            <Grid item md={3} xs={3}>
              <TextField
                fullWidth
                name="env_keep_date"
                id="env_keep_date"
                type="date"
                onChange={handleChange}
                required
                variant="outlined"
                InputProps={{
                  style: {
                    height: "40px",
                  },
                }}
                inputProps={{
                  min: end_date,
                  max: getTenDaysAfterEndDate(end_date),
                }}
              />
            </Grid>
          ) : (
            ""
          )}
        </Grid>
        <Typography variant="h8">
          Enable and select dates to retain the lab environment if the lab is required beyond the stop date or if the lab budget exceeded.
        </Typography>
      </Box>
      <Divider style={{ marginBottom: "20px" }} />
      <Box sx={{ pb: 2, border: '1px #000', borderRadius: '5px', padding: '10px' }}>
        <Box sx={{ pb: 2 }}>
          <Typography variant="h6" gutterBottom>
            {" "}
            Meeting Link{" "}
          </Typography>
        </Box>
        <Typography variant="h8">
          Please share the meeting link
        </Typography>
        <Grid item md={6} xs={12}>
          <TextField
            fullWidth
            name="meetingLink"
            id="meetingLink"
            onChange={handleMeetingLinkChange}
            required
            type="text"
            variant="outlined"
            InputProps={{
              style: {
                height: "40px",
              },
            }}
          ></TextField>
        </Grid>
      </Box>
      <Divider style={{ marginBottom: "20px" }} />
      <Box sx={{ pb: 2, border: '1px #000', borderRadius: '5px', padding: '10px' }}>
        <Grid item xs={12} style={{ marginTop: "-25px" }}>
          <Grid item xs={6}>
            <FormControlLabel
              control={
                <Checkbox
                  onChange={handlecheckBudgetChange}
                  name="disable_copypaste"
                  color="secondary"
                />
              }
              label={<Typography variant="h6"> Disable copy paste for instance lab </Typography>}
            />
          </Grid>
        </Grid>
      </Box>
      <Divider style={{ marginBottom: "20px" }} />
      <Box sx={{ pb: 2, border: '1px #000', borderRadius: '5px', padding: '10px' }}>
        <Grid item xs={12} style={{ marginTop: "-25px" }}>
          <Grid item xs={6}>
            <FormControlLabel
              control={
                <Checkbox
                  onChange={handlecheckBudgetChange}
                  name="identicalpassword"
                  color="secondary"
                />
              }
              label={<Typography variant="h6">Set identical password on all servers</Typography>}
            />
          </Grid>
        </Grid>
      </Box>
      
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          pt: 2,
        }}
      >
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          pt: 2,
        }}
      >
        <div>
          <Tooltip title="Cancel and reset this step"><span>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleReload}
            className={classes}
            sx={{ borderRadius: '50px' }}
          >
            Cancel
          </Button>
          </span></Tooltip>
        </div>
        <div className={classes}>
          {activeStep !== 0 && (
            <Tooltip title="Go back to previous step"><span>
            <Button onClick={handleBack} variant="contained" className={classes} sx={{ borderRadius: '50px', mr: 0.5 }}>
              Back
            </Button>
            </span></Tooltip>
          )}
          <Tooltip title={
            (feedbackState.feedbackCheckbox && selectedDates.length === 0) ||
            (checkstate.checkedB && !temporary.email) ||
            (bothChecked && (!temporary.email || selectedDates.length === 0) ||
              (temporary.env_keep && !temporary.env_keep_date)) ||
            (temporary.guacmoleLabState && (!selectedRelatedLabType || !selectedMasterLabId))
            ? "Complete required fields to proceed" : "Proceed to next step"
          }><span>
          <Button
            variant="contained"
            color="primary"
            onClick={handleNext}
            className={classes}
            disabled={
              (feedbackState.feedbackCheckbox && selectedDates.length === 0) ||
              (checkstate.checkedB && !temporary.email) ||
              (bothChecked && (!temporary.email || selectedDates.length === 0) ||
                (temporary.env_keep && !temporary.env_keep_date)) ||
              (temporary.guacmoleLabState && (!selectedRelatedLabType || !selectedMasterLabId)) 
              // 🚀 This will disable the button when checked
            }
            sx={{ borderRadius: '50px' }}
          >
            Next
          </Button>
          </span></Tooltip>
        </div>
      </Box>
    </React.Fragment>
  );
}
